<app-page-ribbon></app-page-ribbon>
<div class="app-container">
  <header class="app-header" *ngIf="isAuthenticated()">
    <div class="header-content">
      <!-- Logo (Izquierda) -->
      <div class="header-left">
        <img src="assets/logo_letras.png" alt="Restora360" class="header-logo">
      </div>

      <!-- Botones Centrados (Dashboard y Módulos) - Desktop -->
      <div class="header-center desktop-menu">
        <a routerLink="/dashboard" routerLinkActive="active" class="header-btn" title="Dashboard">
          <i class="fas fa-home"></i>
          <span>Dashboard</span>
        </a>
        <div class="dropdown-menu" [class.open]="isDropdownOpen">
          <button class="header-btn dropdown-toggle" (click)="toggleDropdown($event)" type="button" title="Módulos">
            <i class="fas fa-bars"></i>
            <span>Módulos</span>
            <i class="fas fa-chevron-down" [class.rotated]="isDropdownOpen"></i>
          </button>
          <div class="dropdown-content" (click)="$event.stopPropagation()">
            <a *ngIf="canShowRoute('/floor-plan')" routerLink="/floor-plan" routerLinkActive="active" class="dropdown-item" (click)="onDropdownItemClick()">
              <i class="fas fa-map"></i>
              <span>Visualizador de Mesas</span>
            </a>
            <a *ngIf="canShowRoute('/menu')" routerLink="/menu" routerLinkActive="active" class="dropdown-item" (click)="onDropdownItemClick()">
              <i class="fas fa-utensils"></i>
              <span>Menú</span>
            </a>
            <a *ngIf="canShowRoute('/orders')" routerLink="/orders" routerLinkActive="active" class="dropdown-item" (click)="onDropdownItemClick()">
              <i class="fas fa-clipboard-list"></i>
              <span>Pedidos</span>
            </a>
            <a *ngIf="canShowRoute('/kitchen')" routerLink="/kitchen" routerLinkActive="active" class="dropdown-item" (click)="onDropdownItemClick()">
              <i class="fas fa-fire"></i>
              <span>Cocina</span>
            </a>
            <a *ngIf="canShowRoute('/billing')" routerLink="/billing" routerLinkActive="active" class="dropdown-item" (click)="onDropdownItemClick()">
              <i class="fas fa-cash-register"></i>
              <span>Facturación</span>
            </a>
            <a *ngIf="canShowRoute('/reports')" routerLink="/reports" routerLinkActive="active" class="dropdown-item" (click)="onDropdownItemClick()">
              <i class="fas fa-chart-bar"></i>
              <span>Reportes</span>
            </a>
            <a *ngIf="canShowRoute('/insumos')" routerLink="/insumos" routerLinkActive="active" class="dropdown-item" (click)="onDropdownItemClick()">
              <i class="fas fa-boxes"></i>
              <span>Insumos</span>
            </a>
            <a *ngIf="canShowRoute('/configuracion')" routerLink="/configuracion" routerLinkActive="active" class="dropdown-item" (click)="onDropdownItemClick()">
              <i class="fas fa-cog"></i>
              <span>Configuración</span>
            </a>
          </div>
        </div>
        <!-- Selector de sede: solo administrador, después de Módulos -->
        <div *ngIf="isAdmin() && (tableService.locations$ | async) as locations" class="header-sede-wrap desktop-menu">
          <select id="headerSedeSelect" class="header-sede-select" [ngModel]="tableService.selectedLocationId$ | async" (ngModelChange)="onSedeChange($event)">
            <option *ngFor="let loc of locations" [value]="loc.id">{{ loc.name }}</option>
          </select>
        </div>
      </div>

      <!-- Menú de Usuario (Derecha) - Desktop -->
      <div class="header-right desktop-menu">
        <div class="user-menu" [class.open]="isUserMenuOpen">
          <button class="user-toggle" (click)="toggleUserMenu($event)" type="button">
            <i class="fas fa-user-circle"></i>
            <span class="user-name">{{ getCurrentUser()?.name || 'Usuario' }}</span>
            <i class="fas fa-chevron-down" [class.rotated]="isUserMenuOpen"></i>
          </button>
          <div class="user-dropdown" (click)="$event.stopPropagation()">
            <div class="user-info">
              <div class="user-avatar">
                <i class="fas fa-user"></i>
              </div>
              <div class="user-details">
                <strong>{{ getCurrentUser()?.name }}</strong>
                <small>{{ getCurrentUser()?.email }}</small>
                <span class="user-role">{{ getRoleLabel(getCurrentUser()?.role || '') }}</span>
              </div>
            </div>
            <div class="user-divider"></div>
            <button class="user-menu-item" (click)="logout()">
              <i class="fas fa-sign-out-alt"></i>
              <span>Cerrar Sesión</span>
            </button>
          </div>
        </div>
      </div>

      <!-- Menú Mobile/Tablet (3 puntos) -->
      <div class="header-right mobile-menu">
        <button class="mobile-menu-toggle" (click)="toggleMobileMenu($event)" type="button" [class.active]="isMobileMenuOpen">
          <i class="fas fa-ellipsis-v"></i>
        </button>
        <div class="mobile-menu-overlay" *ngIf="isMobileMenuOpen" (click)="closeMobileMenu()"></div>
        <div class="mobile-menu-content" [class.open]="isMobileMenuOpen" (click)="$event.stopPropagation()">
          <!-- Dashboard -->
          <a routerLink="/dashboard" routerLinkActive="active" class="mobile-menu-item" (click)="onDropdownItemClick()">
            <i class="fas fa-home"></i>
            <span>Dashboard</span>
          </a>
          
          <!-- Sede (solo admin) -->
          <div *ngIf="isAdmin() && (tableService.locations$ | async) as locations" class="mobile-menu-section mobile-sede-section">
            <div class="mobile-menu-header">
              <i class="fas fa-building"></i>
              <span>Sede</span>
            </div>
            <div class="mobile-sede-select-wrap">
              <select class="mobile-sede-select" [ngModel]="tableService.selectedLocationId$ | async" (ngModelChange)="onSedeChange($event)">
                <option *ngFor="let loc of locations" [value]="loc.id">{{ loc.name }}</option>
              </select>
            </div>
          </div>
          <!-- Módulos -->
          <div class="mobile-menu-section">
            <div class="mobile-menu-header">
              <i class="fas fa-bars"></i>
              <span>Módulos</span>
            </div>
            <a *ngIf="canShowRoute('/floor-plan')" routerLink="/floor-plan" routerLinkActive="active" class="mobile-menu-subitem" (click)="onDropdownItemClick()">
              <i class="fas fa-map"></i>
              <span>Visualizador de Mesas</span>
            </a>
            <a *ngIf="canShowRoute('/menu')" routerLink="/menu" routerLinkActive="active" class="mobile-menu-subitem" (click)="onDropdownItemClick()">
              <i class="fas fa-utensils"></i>
              <span>Menú</span>
            </a>
            <a *ngIf="canShowRoute('/orders')" routerLink="/orders" routerLinkActive="active" class="mobile-menu-subitem" (click)="onDropdownItemClick()">
              <i class="fas fa-clipboard-list"></i>
              <span>Pedidos</span>
            </a>
            <a *ngIf="canShowRoute('/kitchen')" routerLink="/kitchen" routerLinkActive="active" class="mobile-menu-subitem" (click)="onDropdownItemClick()">
              <i class="fas fa-fire"></i>
              <span>Cocina</span>
            </a>
            <a *ngIf="canShowRoute('/billing')" routerLink="/billing" routerLinkActive="active" class="mobile-menu-subitem" (click)="onDropdownItemClick()">
              <i class="fas fa-cash-register"></i>
              <span>Facturación</span>
            </a>
            <a *ngIf="canShowRoute('/reports')" routerLink="/reports" routerLinkActive="active" class="mobile-menu-subitem" (click)="onDropdownItemClick()">
              <i class="fas fa-chart-bar"></i>
              <span>Reportes</span>
            </a>
            <a *ngIf="canShowRoute('/insumos')" routerLink="/insumos" routerLinkActive="active" class="mobile-menu-subitem" (click)="onDropdownItemClick()">
              <i class="fas fa-boxes"></i>
              <span>Insumos</span>
            </a>
            <a *ngIf="canShowRoute('/configuracion')" routerLink="/configuracion" routerLinkActive="active" class="mobile-menu-subitem" (click)="onDropdownItemClick()">
              <i class="fas fa-cog"></i>
              <span>Configuración</span>
            </a>
          </div>

          <!-- Usuario -->
          <div class="mobile-menu-section">
            <div class="mobile-menu-header">
              <i class="fas fa-user-circle"></i>
              <span>{{ getCurrentUser()?.name || 'Usuario' }}</span>
            </div>
            <div class="mobile-user-info">
              <div class="mobile-user-avatar">
                <i class="fas fa-user"></i>
              </div>
              <div class="mobile-user-details">
                <strong>{{ getCurrentUser()?.name }}</strong>
                <small>{{ getCurrentUser()?.email }}</small>
                <span class="mobile-user-role">{{ getRoleLabel(getCurrentUser()?.role || '') }}</span>
              </div>
            </div>
            <button class="mobile-menu-item logout-item" (click)="logout()">
              <i class="fas fa-sign-out-alt"></i>
              <span>Cerrar Sesión</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </header>

  <main class="app-main">
    <router-outlet></router-outlet>
  </main>
</div>

